export enum CookieType {
  AccessToken = "AccessToken"
}
